/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The Invoice model module.
 * @module model/Invoice
 * @version v0
 */
export default class Invoice {
  /**
   * Constructs a new <code>Invoice</code>.
   * @alias module:model/Invoice
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Invoice</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Invoice} obj Optional instance to populate.
   * @return {module:model/Invoice} The populated <code>Invoice</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Invoice();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('accountId'))
        obj.accountId = ApiClient.convertToType(data['accountId'], 'String');
      if (data.hasOwnProperty('amount'))
        obj.amount = ApiClient.convertToType(data['amount'], 'Number');
      if (data.hasOwnProperty('currency'))
        obj.currency = ApiClient.convertToType(data['currency'], 'String');
      if (data.hasOwnProperty('planId'))
        obj.planId = ApiClient.convertToType(data['planId'], 'String');
      if (data.hasOwnProperty('period'))
        obj.period = ApiClient.convertToType(data['period'], 'Number');
      if (data.hasOwnProperty('paid'))
        obj.paid = ApiClient.convertToType(data['paid'], 'Boolean');
      if (data.hasOwnProperty('paidWhen'))
        obj.paidWhen = ApiClient.convertToType(data['paidWhen'], 'Number');
      if (data.hasOwnProperty('emittedWhen'))
        obj.emittedWhen = ApiClient.convertToType(data['emittedWhen'], 'Number');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('paymentReference'))
        obj.paymentReference = ApiClient.convertToType(data['paymentReference'], 'String');
      if (data.hasOwnProperty('paymentProcessorId'))
        obj.paymentProcessorId = ApiClient.convertToType(data['paymentProcessorId'], 'String');
      if (data.hasOwnProperty('numberOfEditors'))
        obj.numberOfEditors = ApiClient.convertToType(data['numberOfEditors'], 'Number');
      if (data.hasOwnProperty('numberOfSources'))
        obj.numberOfSources = ApiClient.convertToType(data['numberOfSources'], 'Number');
      if (data.hasOwnProperty('numberOfSnapshots'))
        obj.numberOfSnapshots = ApiClient.convertToType(data['numberOfSnapshots'], 'Number');
      if (data.hasOwnProperty('numberOfViewers'))
        obj.numberOfViewers = ApiClient.convertToType(data['numberOfViewers'], 'Number');
      if (data.hasOwnProperty('subscriptionId'))
        obj.subscriptionId = ApiClient.convertToType(data['subscriptionId'], 'String');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'Number');
      if (data.hasOwnProperty('invoiceGenerationError'))
        obj.invoiceGenerationError = ApiClient.convertToType(data['invoiceGenerationError'], 'String');
      if (data.hasOwnProperty('freqency'))
        obj.freqency = ApiClient.convertToType(data['freqency'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
Invoice.prototype.id = undefined;

/**
 * @member {String} accountId
 */
Invoice.prototype.accountId = undefined;

/**
 * @member {Number} amount
 */
Invoice.prototype.amount = undefined;

/**
 * @member {String} currency
 */
Invoice.prototype.currency = undefined;

/**
 * @member {String} planId
 */
Invoice.prototype.planId = undefined;

/**
 * @member {Number} period
 */
Invoice.prototype.period = undefined;

/**
 * @member {Boolean} paid
 */
Invoice.prototype.paid = undefined;

/**
 * @member {Number} paidWhen
 */
Invoice.prototype.paidWhen = undefined;

/**
 * @member {Number} emittedWhen
 */
Invoice.prototype.emittedWhen = undefined;

/**
 * @member {String} description
 */
Invoice.prototype.description = undefined;

/**
 * @member {String} paymentReference
 */
Invoice.prototype.paymentReference = undefined;

/**
 * @member {String} paymentProcessorId
 */
Invoice.prototype.paymentProcessorId = undefined;

/**
 * @member {Number} numberOfEditors
 */
Invoice.prototype.numberOfEditors = undefined;

/**
 * @member {Number} numberOfSources
 */
Invoice.prototype.numberOfSources = undefined;

/**
 * @member {Number} numberOfSnapshots
 */
Invoice.prototype.numberOfSnapshots = undefined;

/**
 * @member {Number} numberOfViewers
 */
Invoice.prototype.numberOfViewers = undefined;

/**
 * @member {String} subscriptionId
 */
Invoice.prototype.subscriptionId = undefined;

/**
 * @member {Number} status
 */
Invoice.prototype.status = undefined;

/**
 * @member {String} invoiceGenerationError
 */
Invoice.prototype.invoiceGenerationError = undefined;

/**
 * @member {String} freqency
 */
Invoice.prototype.freqency = undefined;

